export default __webpack_public_path__ + "static/media/sh-ofmp-transparent-bg.cef6dfc6.png";